import type { ReactNode } from 'react'
import { cn } from '@/lib/utils/cn'

export interface FieldProps {
  label: string
  htmlFor?: string
  hint?: ReactNode
  error?: ReactNode
  children: ReactNode
  className?: string
}

/** Label + control + hint/error, so every form row in the app is spaced alike. */
export function Field({
  label,
  htmlFor,
  hint,
  error,
  children,
  className,
}: FieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <label
        htmlFor={htmlFor}
        className="block text-xs font-medium tracking-wide text-muted"
      >
        {label}
      </label>
      {children}
      {error ? (
        <p className="text-xs text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs leading-relaxed text-subtle">{hint}</p>
      ) : null}
    </div>
  )
}
